'use strict';
import startsWith from 'lodash/startsWith';
import {stateGo} from 'redux-ui-router';
import {stateGoExit} from '../../app/actions';
import {getAssetProject, getOrganization} from '../../app/model/reducers/state';
import {navStates} from '../../app/router';
import {SCOPE_DESTROY} from '../../config/constants/view-events';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {eventToObservable} from '../../core-utilities/rx-utils';


AssetController.$inject = [
  '$scope',
  '$ngRedux',
  '$state',
  'EventBus',
];

export function AssetController(
  $scope,
  $ngRedux,
  $state,
  EventBus,
) {
  EventBus.on('event:deleting:organization', onDeleteOrganization, $scope);
  EventBus.on('event:deleting:asset', onDeleteAsset, $scope);
  EventBus.on('event:deleting:assetProject', onDeleteAssetProject, $scope);

  $ngRedux.state$
    .takeUntil(eventToObservable($scope, SCOPE_DESTROY))
    .map(getAssetProject)
    .distinctUntilChanged(null, assetProject => getId(assetProject))
    .subscribe(withNewAssetProject);

  function withNewAssetProject(assetProject) {
    $scope.$evalAsync(() => $scope.assetProject = assetProject);
  }

  function onDeleteOrganization() {
    if (startsWith($state.current.name, 'app.assets')) {
      $ngRedux.dispatch(stateGo(navStates.orgsList));
    }
  }

  function onDeleteAsset() {
    if (startsWith($state.current.name, 'app.assets')) {
      const rootState = $ngRedux.getState();
      if (getOrganization(rootState)) {
        $ngRedux.dispatch(stateGoExit({state: navStates.assetsList}));
      } else {
        $ngRedux.dispatch(stateGo(navStates.orgsList));
      }
    }
  }

  function onDeleteAssetProject() {
    if (startsWith($state.current.name, 'app.assets')) {
      const rootState = $ngRedux.getState();
      if (getOrganization(rootState)) {
        $ngRedux.dispatch(stateGoExit({state: navStates.assetProjectsList}));
      } else {
        $ngRedux.dispatch(stateGo(navStates.orgsList));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/assets/controllers/AssetController.js